import strings from '../../Localization/Localization';

import React from 'react';

import {
  index,
  getFromId,
  getIdentificationFromId,
  getPreviousPricesFromId,
  editFromId,
  newItem,
} from '../../API/CreditPacks';
import {
  form,
  previousPricesForm
} from '../Form/creditPacks';
import { form as searchForm } from '../Form/Search/creditPacks';

import { creditPacks as routes } from '../Route/routes';

export const conf = {
  index: {
    pageTitle: strings.common.homepage.creditPack,

    id: "creditPack",
    api: index,
    onClickItem: {
      redirect: true,
      path: (id) => routes.routes.show.createPath(id)
    },

    searchForm: searchForm,
    computeSearch: (search) => {
      let result = {};
      if(search.available) {
        result["available"] = search.available;
      }
      return result;
    },

    availableItemDisplay:['tab'],
    itemDisplay: {
      tab: {
        headers: [
          {
            id: "name",
            label: "Nom",
            value: "name"
          },
          {
            id: "quantity",
            label: "Quantité",
            value: "quantity"
          },
          {
            id: "quantityFree",
            label: "Quantité offerte",
            value: "quantity_free"
          },
          {
            id: "price",
            label: "Prix",
            type: "price",
            value: "price",
          },
          {
            id: "available",
            label: <>&nbsp;&nbsp;<i className="icon-checkmark"/>&nbsp;&nbsp;</>,
            value: item => {
              if(item["available"] === true || item["available"] === 1) {
                return (
                  <div className="item-index-status item-index-status-validated-icon"><i className="icon-checkmark"/></div>
                );
              }
              else {
                return (
                  <div className="item-index-status item-index-status-danger-icon"><i className="icon-cross"/></div>
                );
              }
            }
          },
        ]
      },
    },

    sizing: {
      numberColumn: 2,
      formSizeMd: 12
    },
  },
  show: {
    pageTitle: strings.common.homepage.creditPack,
    pageTitleReturnPath: () => routes.routes.index.createPath(),
    breadcrumbIdentifier: (item) => {
      return `${item["name"]}`
    },

    apiGet: getIdentificationFromId,

    extendedHeader: true,
    header: {
      imgUrl: (item) => null,
      placeholderTitle: (item) => item["name"].split(' ').map((item) => item[0]).reduce((prev, curr) => prev+curr),
      label: (item) => item["name"],
      additionalData1: (item) => item["quantity"] + " + " + item["quantity_free"],
      additionalData2: (item) => item["price"],
      additionalData3: (item) => "",
    },

    menu: (item) => {
      let buttons = [];

      return buttons;
    },

    tabs: {
      main: {
        title: strings.creditPack.tab.main,
        type: 'form',
        form: form,

        onUpdateItem: (data) => {},
        onSubmit: () => {},
        postEdit: {
          type: 'tab',
          tabId: 'main'
        },

        apiGet: getFromId,
        apiEdit: editFromId,

        role: ['ROLE_NYUKOM'],
        editable: ['ROLE_NYUKOM']
      },
      previousPrice: {
        title: strings.creditPack.tab.previousPrice,
        type: 'form',
        form: previousPricesForm,

        onUpdateItem: (data) => {},

        apiGet: getPreviousPricesFromId,

        role: ['ROLE_NYUKOM'],
        editable: false
      },
    }
  },
  new: {
    pageTitle: strings.creditPack.new.title,

    api: newItem,
    empty: {},
    form: form,
    onSubmit: (item) => {},
    postNew: {
      type: 'path',
      path: (id) => routes.routes.show.createPath(id)
    }
  }
}
